import React from 'react';
import './my-loot-keys-list.styles.scss'
import PlayerRecordsList from '@/components/SHARED/player-records-list/player-records-list.component';

const MyLootKeysList = ({
  playerData,
  gameElements,
  gameData
}) => {

  return (
    <div className="my-loot-keys-list">
      <PlayerRecordsList
        gameData={gameData}
        playerData={playerData}
        gameElements={gameElements}
        activityType='lootKey'
        title='Redeemed Loot Keys'
        summaryLabel='Redeemed Loot Keys'
        summaryIcon='/images/icons/lootkey.png'
        summaryCount={
          playerData?.lootKeys
            ? Object.keys(playerData.lootKeys).length
            : 0
        }
        emptyText='No redeemed loot keys yet...' />
    </div>
  );
};

export default MyLootKeysList;
